import React, { FC, ReactElement, useEffect, useState } from 'react';
import cns from 'classnames';
import './SpeakersPage.sass';
import { useSelector } from 'react-redux';
// import { useHistory } from 'react-router-dom';
import { getScheduleStreams } from '../../../stores/reducers/userData';
import { getSpeakers } from '../../../helpers/speakers';
import localeFieldResolver from '../../../helpers/locale-field-finder';
import { internalizationState } from '../../../stores/reducers/sections';

export interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionName: string;
}

const SpeakersPage: FC<Props> = ({ className, bgSettings, sectionName }): ReactElement => {
  const streams = useSelector(getScheduleStreams);
  // const history = useHistory();
  const [speakers, setSpeakers] = useState<any>({});
  const { activeLangState } = useSelector(internalizationState);

  useEffect(() => {
    setSpeakers(getSpeakers(streams));
  }, [streams]);

  return (
    <section
      className={cns(
        'static-page-section speakers',
        // bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
        className
      )}
      style={{ backgroundColor: bgSettings?.color }}>
      <div className="inner-section__head speakers">
        <h1>{sectionName}</h1>
      </div>
      <div className="container">
        <div style={{ padding: '14px 0' }} />
        <ul className="speakers-list">
          {Object.keys(speakers).length &&
            Object.keys(speakers).map((id) => (
              <li key={speakers[id].id} id={speakers[id].id} className="speaker-item">
                <div className="speaker-item__photo">
                  <img src={speakers[id].photo} alt="" />
                </div>
                <div className="speaker-item-info">
                  <div className="speaker-item__name">{ localeFieldResolver(speakers[id], 'fullnameRu', activeLangState) }</div>
                  <p className="user-fs-text__sm">{ localeFieldResolver(speakers[id], 'descriptionRu', activeLangState) }</p>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </section>
  );
};

export default SpeakersPage;
